import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SproutIcon, Search, Bell, Menu as MenuIcon, X, User, LogOut, Settings, HelpCircle } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import { NotificationSystem } from '../Notifications/NotificationSystem';
export const UserHeader = () => {
  const {
    user,
    logout,
    userType
  } = useUser();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  // Get dashboard link based on user type
  const getDashboardLink = () => {
    if (!userType) return '/';
    return `/${userType}/dashboard`;
  };
  return <header className="bg-white shadow-sm sticky top-0 z-40" data-id="element-398">
      <div className="px-4 py-3" data-id="element-399">
        <div className="flex items-center justify-between" data-id="element-400">
          {/* Left: Logo and Menu Toggle */}
          <div className="flex items-center" data-id="element-401">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 mr-2 rounded-md text-gray-600 lg:hidden" data-id="element-402">
              {isMenuOpen ? <X size={24} data-id="element-403" /> : <MenuIcon size={24} data-id="element-404" />}
            </button>
            <Link to={getDashboardLink()} className="flex items-center" data-id="element-405">
              <div className="bg-leaf-green rounded-full p-1 mr-2" data-id="element-406">
                <SproutIcon size={24} className="text-white" data-id="element-407" />
              </div>
              <span className="text-xl font-montserrat font-bold text-soil-brown" data-id="element-408">
                GrowConnect
              </span>
            </Link>
          </div>
          {/* Right: Search, Notifications, Profile */}
          <div className="flex items-center space-x-2" data-id="element-409">
            {/* Search */}
            <div className="relative" data-id="element-410">
              <button onClick={() => setIsSearchOpen(!isSearchOpen)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Search" data-id="element-411">
                <Search size={20} className="text-gray-700" data-id="element-412" />
              </button>
              {/* Search Popup */}
              {isSearchOpen && <div className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg p-3 z-50" data-id="element-413">
                  <div className="relative" data-id="element-414">
                    <input type="text" placeholder="Search GrowConnect..." className="input-field pl-9 pr-4 py-2" autoFocus data-id="element-415" />
                    <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-416" />
                  </div>
                  <div className="mt-2 text-xs text-gray-500" data-id="element-417">
                    <p data-id="element-418">Try searching for projects, investors, or crops</p>
                  </div>
                </div>}
            </div>
            {/* Notifications */}
            <NotificationSystem data-id="element-419" />
            {/* Profile */}
            <div className="relative" data-id="element-420">
              <button onClick={() => setIsProfileOpen(!isProfileOpen)} className="flex items-center focus:outline-none" data-id="element-421">
                <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-leaf-green" data-id="element-422">
                  {user?.profileImage ? <img src={user.profileImage} alt={user.name} className="w-full h-full object-cover" data-id="element-423" /> : <div className="w-full h-full flex items-center justify-center bg-leaf-green/20" data-id="element-424">
                      <User size={16} className="text-leaf-green" data-id="element-425" />
                    </div>}
                </div>
              </button>
              {isProfileOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-50" data-id="element-426">
                  <div className="px-4 py-2 border-b" data-id="element-427">
                    <p className="text-sm font-medium" data-id="element-428">{user?.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-429">{user?.email}</p>
                  </div>
                  <Link to={`/${userType}/profile`} className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsProfileOpen(false)} data-id="element-430">
                    <User size={16} className="mr-2" data-id="element-431" />
                    Profile
                  </Link>
                  <Link to={`/${userType}/settings`} className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsProfileOpen(false)} data-id="element-432">
                    <Settings size={16} className="mr-2" data-id="element-433" />
                    Settings
                  </Link>
                  <Link to="/help" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsProfileOpen(false)} data-id="element-434">
                    <HelpCircle size={16} className="mr-2" data-id="element-435" />
                    Help & Support
                  </Link>
                  <div className="border-t" data-id="element-436">
                    <button onClick={() => {
                  logout();
                  setIsProfileOpen(false);
                }} className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-437">
                      <LogOut size={16} className="mr-2" data-id="element-438" />
                      Sign out
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </header>;
};